import { styled } from "../imports";
import Box from "./Box";
import { sizeProps, overflowProps } from "../props";
import { prop, zIndex } from "../utils";
var Position = /*#__PURE__*/styled(Box, {
  label: "Position",
  target: "css-wej4zz0"
})(sizeProps, ";", overflowProps, ";", prop("position", function (val) {
  return "position:" + val;
}), ";", prop("relative", "position:relative"), ";", prop("absolute", "position:absolute"), ";", prop("fixed", "position:fixed"), ";", prop("sticky", "position:sticky"), ";", prop("zIndex", function (val, rawVal, p) {
  if (typeof rawVal === "string") return "z-index:" + zIndex(rawVal)(p);
  return "z-index:" + rawVal;
}), ";", prop("top", function (val) {
  return "top:" + val;
}), ";", prop("right", function (val) {
  return "right:" + val;
}), ";", prop("bottom", function (val) {
  return "bottom:" + val;
}), ";", prop("left", function (val) {
  return "left:" + val;
}), ";", function (p) {
  return p.top === true && "top:0";
}, ";", function (p) {
  return p.right === true && "right:0";
}, ";", function (p) {
  return p.bottom === true && "bottom:0";
}, ";", function (p) {
  return p.left === true && "left:0";
}, ";");
Position.displayName = "Position";
export default Position;